import React from 'react'
import { Container, Row, Col, ListGroup } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const ReportsScreen = () => {
  return (
    <Container>
      <Row className='my-2'>
        <Col>
          <h3>Reports</h3>
          <ListGroup variant='flush'>
            <LinkContainer to='/charts'>
              <ListGroup.Item action>Daily Total Spend</ListGroup.Item>
            </LinkContainer>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  )
}

export default ReportsScreen
